<template>
    <v-container fluid class="pa-3">
      <v-layout column justify-center text-xs-center>
        <v-flex xs12>
          <a href="https://accessibleretail.co.uk/" target="_blank" title="Visit Website">
            <v-img contain="" height="150" :src="require('@/assets/ar-logo.svg')"></v-img>
          </a>
        </v-flex>
        <v-flex xs12>
          <v-card-title primary-title>
            <v-container fluid>
              <v-layout align-center justify-center column>
                <v-flex sm12 class="text-xs-center">
                  <p :class="fontClass">This feature will be added shortly</p>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-title>
        </v-flex>
      </v-layout>
    </v-container>
</template>

<script>

import { mapActions } from 'vuex'

export default {
  name: 'Database',
  data: () => ({
    loading: false,
    token: null
  }),
  created () {
    this.setTitle({ title: 'Database' })
  },
  computed: {
    fontClass () {
      return (this.$vuetify.breakpoint.xsOnly) ? 'caption' : 'headline'
    }
  },
  methods: {
    ...mapActions(
      'application', {
        setTitle: 'setTitle'
      }
    )
  }
}
</script>
